import type { CollectionTree as CollectionTreeType } from '@maker-toolchest/shared';
import { CollectionTreeNode } from './CollectionTreeNode';
import { Loader2, FolderOpen } from 'lucide-react';

interface CollectionTreeProps {
  collections: CollectionTreeType[];
  isLoading?: boolean;
  selectedCollectionIds?: string[];
  onSelect?: (collectionId: string) => void;
  showCheckbox?: boolean;
  emptyMessage?: string;
}

export function CollectionTree({
  collections,
  isLoading = false,
  selectedCollectionIds = [],
  onSelect,
  showCheckbox = false,
  emptyMessage = 'No collections yet',
}: CollectionTreeProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="h-6 w-6 animate-spin text-foreground-muted" />
      </div>
    );
  }

  if (collections.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <FolderOpen className="h-12 w-12 text-foreground-muted mb-3" />
        <p className="text-sm text-foreground-muted">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="space-y-1">
      {collections.map((collection) => (
        <CollectionTreeNode
          key={collection.id}
          collection={collection}
          level={0}
          selectedCollectionIds={selectedCollectionIds}
          onSelect={onSelect}
          showCheckbox={showCheckbox}
        />
      ))}
    </div>
  );
}
